import React, { memo } from "react";
import ClampLinesBase from "react-clamp-lines";

type NumberFigureProps = {
  className?: string;
  titleClass?: string;
  valueClass?: string;
  title?: string;
  value?: React.ReactNode;
};

const ClampLinesComponent = ClampLinesBase as React.ElementType;

const NumberFigure = ({
  className = "",
  titleClass = "",
  valueClass = "",
  title = "",
  value = "",
}: NumberFigureProps) => {
  const formattedValue = String(value) === "0" || value ? value : "--";

  return (
    <div
      className={`rp-number-figure h-100 mb-2 text-center text-md-left ${className}`}
      title={title}
    >
      <ClampLinesComponent
        key={title}
        text={title}
        lines={2}
        className={`widget-title rp-line-clamp ${titleClass} `}
        onClampStart={() => {}}
      />

      <div
        title={formattedValue === "--" ? "N/A" : String(formattedValue)}
        className={`fs-20 font-weight-bold count widget-state-value ${valueClass} `}
      >
        {formattedValue}
      </div>
    </div>
  );
};

export default memo(NumberFigure);
